type IdleScheduler = (callback: () => void) => () => void

export function createQuietIdleTask(
  callback: () => void,
  quietMs: number,
  scheduleIdle: IdleScheduler,
) {
  let quietHandle: number | undefined
  let cancelIdle = () => {}

  const cancel = () => {
    window.clearTimeout(quietHandle)
    quietHandle = undefined
    cancelIdle()
    cancelIdle = () => {}
  }

  const schedule = () => {
    cancel()
    quietHandle = window.setTimeout(() => {
      quietHandle = undefined
      cancelIdle = scheduleIdle(callback)
    }, quietMs)
  }

  return { cancel, schedule }
}
